import { __makeTemplateObject } from "tslib";
import Typography from '../Typography';
import styled from 'styled-components';
var Display1 = styled(Typography).attrs({
    type: 'display1',
    as: 'h3',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Display2 = styled(Typography).attrs({
    type: 'display2',
    as: 'h3',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Display3 = styled(Typography).attrs({
    type: 'display3',
    as: 'h2',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Display4 = styled(Typography).attrs({
    type: 'display4',
    as: 'h1',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Headline = styled(Typography).attrs({
    type: 'headline',
    as: 'h5',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Title = styled(Typography).attrs({
    type: 'title',
    as: 'h5',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Subheading = styled(Typography).attrs({
    type: 'subheading',
    as: 'h6',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Body2 = styled(Typography).attrs({
    type: 'body2',
    as: 'p',
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Body1 = styled(Typography).attrs({
    type: 'body1',
    as: 'p',
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Caption = styled(Typography).attrs({
    type: 'caption',
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var Button = styled(Typography).attrs({
    type: 'button',
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
export default Typography;
export { Display4, Display3, Display2, Display1, Headline, Title, Subheading, Body2, Body1, Caption, Button, Display4 as H1, Display3 as H2, Display2 as H3, Display1 as H4, Headline as H5, Subheading as H6, Body1 as P, };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=index.js.map